<template>
  <v-dialog v-model="dialog" persistent max-width="500">
    <template v-slot:activator="{ on }">
      <v-btn rounded class="primary text-capitalize f-14 lh-17 mt-2" v-on="on">
        <v-icon>mdi-filter-outline</v-icon>
        Filter
      </v-btn>
    </template>
    <v-form ref="form">
      <v-card class="rounded-12">
        <v-card-title
          class="primary white--text fs-16 lh-20 font-weight-bold py-4 px-6"
        >
          <span class="pa-0">Filter</span>
          <v-spacer></v-spacer>
          <v-btn color="white" fab x-small depressed>
            <v-icon
              @click="dialog = false"
              color="primary"
              class="fs-18 font-weight-bold"
            >
              close
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-perfect-scroll
          class="drawer-menu--scroll-dialog"
          :settings="scrollSettingsFilter"
        >
          <v-card-text class="px-6 py-4 border-b-1">
            <div class="mb-0">
              <v-row>
                <v-col>
                  <label
                    class="mb-1 d-block fs-12 font-weight-500"
                    for="startYear"
                  >
                    Year
                  </label>
                  <date-picker
                    id="startYear"
                    v-model="start_year"
                    type="year"
                    placeholder="Select Year"
                    format="YYYY"
                    class="fs-12"
                  >
                  </date-picker>
                </v-col>
                <!-- <v-col>
                  <label
                    class="mb-1 d-block fs-12 font-weight-500"
                    for="yearEnd"
                  >
                    Year End
                  </label>
                  <v-autocomplete
                    id="yearEnd"
                    :items="years"
                    v-model="yearEnd"
                    single-line
                    dense
                    hide-details
                    placeholder="Select Year End"
                    append-icon="mdi-calendar"
                    :rules="yearEndRules"
                    outlined
                  ></v-autocomplete>
                </v-col> -->
              </v-row>
              <v-row>
                <v-col class="py-0">
                  <label class="mb-1 d-block fs-12 font-weight-500">
                    Start Created Date
                  </label>
                  <v-menu
                    :close-on-content-click="false"
                    transition="scale-transition"
                    nudge-bottom="-10"
                    min-width="290px"
                    v-model="menu_startCreatedDate"
                    offset-y
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        id="startCreatedDate"
                        placeholder="Start Created Date"
                        append-icon="event"
                        single-line
                        dense
                        outlined
                        readonly
                        clearable
                        :rules="startCreatedDateRules"
                        v-on="on"
                        v-model="start_created_date"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="start_created_date"
                      @input="menu_startCreatedDate = false"
                      no-title
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col class="py-0">
                  <label class="mb-1 d-block fs-12 font-weight-500">
                    End Created Date
                  </label>
                  <v-menu
                    :close-on-content-click="false"
                    transition="scale-transition"
                    nudge-bottom="-10"
                    min-width="290px"
                    v-model="menu_endCreatedDate"
                    offset-y
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        id="endCreatedDate"
                        placeholder="End Created Date"
                        append-icon="event"
                        single-line
                        dense
                        clearable
                        outlined
                        readonly
                        :rules="endCreatedDateRules"
                        v-on="on"
                        v-model="end_created_date"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="end_created_date"
                      @input="menu_endCreatedDate = false"
                      no-title
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0">
                  <label class="mb-1 d-block fs-12 font-weight-500">
                    Start Submitted Date
                  </label>
                  <v-menu
                    :close-on-content-click="false"
                    transition="scale-transition"
                    nudge-bottom="-10"
                    min-width="290px"
                    v-model="menu_startSubmittedDate"
                    offset-y
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        id="startSubmittedDate"
                        placeholder="Start Submitted Date"
                        append-icon="event"
                        single-line
                        dense
                        clearable
                        outlined
                        readonly
                        :rules="startSubmittedDateRules"
                        v-on="on"
                        v-model="start_date_submitted"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="start_date_submitted"
                      @input="menu_startSubmittedDate = false"
                      no-title
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col class="py-0">
                  <label class="mb-1 d-block fs-12 font-weight-500">
                    End Submitted Date
                  </label>
                  <v-menu
                    :close-on-content-click="false"
                    transition="scale-transition"
                    nudge-bottom="-10"
                    min-width="290px"
                    v-model="menu_endSubmittedDate"
                    offset-y
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        id="endSubmittedDate"
                        placeholder="End Submitted Date"
                        append-icon="event"
                        single-line
                        dense
                        clearable
                        outlined
                        readonly
                        :rules="endSubmittedDateRules"
                        v-on="on"
                        v-model="end_date_submitted"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="end_date_submitted"
                      @input="menu_endSubmittedDate = false"
                      no-title
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0">
                  <label class="mb-1 d-block fs-12 font-weight-500">
                    Start Approved Date
                  </label>
                  <v-menu
                    :close-on-content-click="false"
                    transition="scale-transition"
                    nudge-bottom="-10"
                    min-width="290px"
                    v-model="menu_startApprovedDate"
                    offset-y
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        id="startApprovedDate"
                        placeholder="Start Approved Date"
                        append-icon="event"
                        single-line
                        dense
                        clearable
                        outlined
                        readonly
                        :rules="startApprovedDateRules"
                        v-on="on"
                        v-model="start_date_fully_approved"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="start_date_fully_approved"
                      @input="menu_startApprovedDate = false"
                      no-title
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col class="py-0">
                  <label class="mb-1 d-block fs-12 font-weight-500">
                    End Approved Date
                  </label>
                  <v-menu
                    :close-on-content-click="false"
                    transition="scale-transition"
                    nudge-bottom="-10"
                    min-width="290px"
                    v-model="menu_endApprovedDate"
                    offset-y
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        id="endApprovedDate"
                        placeholder="End Approved Date"
                        append-icon="event"
                        single-line
                        dense
                        clearable
                        outlined
                        readonly
                        :rules="endApprovedDateRules"
                        v-on="on"
                        v-model="end_date_fully_approved"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="end_date_fully_approved"
                      @input="menu_endApprovedDate = false"
                      no-title
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </div>
            <div class="mb-3">
              <label class="mb-1 d-block fs-12 font-weight-500" for="house"
                >House</label
              >
              <v-autocomplete
                single-line
                dense
                hide-details
                clearable
                id="house"
                placeholder="Select House"
                item-text="name"
                return-object
                :items="housesNAV"
                v-model="house"
                outlined
              ></v-autocomplete>
            </div>
            <div class="mb-3">
              <label class="mb-1 d-block fs-12 font-weight-500" for="region"
                >Region</label
              >
              <v-autocomplete
                single-line
                dense
                hide-details
                id="region"
                placeholder="Select Region"
                v-model="region"
                :items="regionItems"
                item-text="name"
                item-value="name"
                clearable
                outlined
              ></v-autocomplete>
            </div>
            <div class="mb-3">
              <label class="mb-1 d-block fs-12 font-weight-500" for="district"
                >District</label
              >
              <v-autocomplete
                single-line
                dense
                hide-details
                id="district"
                placeholder="Select District"
                v-model="district"
                :items="districtItems"
                item-text="name"
                item-value="name"
                clearable
                outlined
              ></v-autocomplete>
            </div>
            <div class="mb-3">
              <label class="mb-1 d-block fs-12 font-weight-500" for="activity">
                By Activity
              </label>
              <v-autocomplete
                v-model="activity"
                single-line
                dense
                hide-details
                id="activity"
                placeholder="Select Activity"
                :items="activities"
                item-text="name"
                item-value="name"
                clearable
                outlined
              ></v-autocomplete>
            </div>
            <div class="mb-0">
              <label class="mb-1 d-block fs-12 font-weight-500" for="status">
                By Status
              </label>
              <v-autocomplete
                v-model="status"
                single-line
                dense
                hide-details
                id="status"
                placeholder="Select Status"
                :items="statuses"
                item-text="name"
                item-value="value"
                multiple
                clearable
                outlined
              ></v-autocomplete>
            </div>
          </v-card-text>
        </v-perfect-scroll>
        <v-card-actions class="px-3">
          <v-col cols="4">
            <v-btn
              block
              color="#6A7589"
              dark
              rounded
              class="btn-medium rounded-xl px-4"
              @click="resetFilter"
            >
              <v-icon class="mr-2">mdi-refresh</v-icon>
              Reset Filter
            </v-btn>
          </v-col>
          <v-spacer />
          <v-col cols="4">
            <v-btn
              block
              color="primary"
              rounded
              class="btn-medium rounded-xl px-4 text-right"
              @click="handleFilter"
            >
              <v-icon class="mr-2">mdi-filter-outline</v-icon>
              Filter
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { yearLists } from '@/utils/helpers';
import { mapState } from 'vuex';

export default {
  props: {
    isFormRequest: {
      default: false
    }
  },
  name: 'dashboard-filter',
  data: () => ({
    dialog: false,
    menu_start_year: false,
    menu_startCreatedDate: false,
    menu_endCreatedDate: false,
    menu_startSubmittedDate: false,
    menu_endSubmittedDate: false,
    menu_startApprovedDate: false,
    menu_endApprovedDate: false,
    housesNAV: [],
    scrollSettingsFilter: {
      maxScrollbarLength: 283
    }
  }),
  computed: {
    ...mapState('sshcp', [
      'regionsMapping',
      'houses',
      'districtByRegion',
      'filter',
      'activities'
    ]),
    statuses() {
      return [
        {
          name: 'Draft',
          value: 'draft'
        },
        {
          name: 'Submitted',
          value: 'submitted'
        },
        {
          name: 'Approval Process',
          value: 'approval_process'
        },
        {
          name: 'Rejected',
          value: 'rejected'
        },
        {
          name: 'Fully Approved',
          value: 'fully_approved'
        },
        {
          name: 'Waiting BO Approval',
          value: 'waiting_bo_approval'
        },
        {
          name: 'Waiting HN Approval',
          value: 'waiting_hn_approval'
        },
        {
          name: 'Waiting For Receipt',
          value: 'waiting_for_receipt'
        },
        {
          name: 'Waiting To Complete',
          value: 'waiting_to_complete'
        },
        {
          name: 'Preval Reject',
          value: 'preval_reject'
        },
        {
          name: 'Completed',
          value: 'completed'
        }
      ];
    },
    years() {
      return yearLists(2019, new Date().getFullYear() + 50);
    },
    regionItems() {
      return this.regionsMapping;
    },
    districtItems() {
      if (this.region) return this.districtByRegion.districtMappings;

      return this.districtByRegion?.districtMappings || [];
    },
    region: {
      set(val) {
        this.setFilter({
          region: val
        });
      },
      get() {
        return this.$store.getters['sshcp/filter'].region;
      }
    },
    house: {
      set(val) {
        this.setFilter({
          house: val
        });
      },
      get() {
        return this.$store.getters['sshcp/filter'].house;
      }
    },
    district: {
      set(val) {
        this.setFilter({
          district: val
        });
      },
      get() {
        return this.$store.getters['sshcp/filter'].district;
      }
    },
    start_year: {
      set(val) {
        this.setFilter({
          start_year: val
        });
      },
      get() {
        return this.$store.getters['sshcp/filter'].start_year;
      }
    },
    yearEnd: {
      set(val) {
        this.setFilter({
          yearEnd: val
        });
      },
      get() {
        return this.$store.getters['sshcp/filter'].yearEnd;
      }
    },
    start_created_date: {
      set(val) {
        this.setFilter({
          start_created_date: val
        });
      },
      get() {
        return this.$store.getters['sshcp/filter'].start_created_date;
      }
    },
    end_created_date: {
      set(val) {
        this.setFilter({
          end_created_date: val
        });
      },
      get() {
        return this.$store.getters['sshcp/filter'].end_created_date;
      }
    },
    start_date_submitted: {
      set(val) {
        this.setFilter({
          start_date_submitted: val
        });
      },
      get() {
        return this.$store.getters['sshcp/filter'].start_date_submitted;
      }
    },
    end_date_submitted: {
      set(val) {
        this.setFilter({
          end_date_submitted: val
        });
      },
      get() {
        return this.$store.getters['sshcp/filter'].end_date_submitted;
      }
    },
    start_date_fully_approved: {
      set(val) {
        this.setFilter({
          start_date_fully_approved: val
        });
      },
      get() {
        return this.$store.getters['sshcp/filter'].start_date_fully_approved;
      }
    },
    end_date_fully_approved: {
      set(val) {
        this.setFilter({
          end_date_fully_approved: val
        });
      },
      get() {
        return this.$store.getters['sshcp/filter'].end_date_fully_approved;
      }
    },
    status: {
      set(val) {
        this.setFilter({
          status: val
        });
      },
      get() {
        return this.$store.getters['sshcp/filter'].status;
      }
    },
    activity: {
      set(val) {
        this.setFilter({
          type_of_activity: val
        });
      },
      get() {
        return this.$store.getters['sshcp/filter'].type_of_activity;
      }
    },
    startCreatedDateRules() {
      if (this.end_created_date < this.start_created_date) {
        return ['End Date can not lower than Start Date'];
      }
      return [];
    },
    endCreatedDateRules() {
      if (this.start_created_date > this.end_created_date) {
        return ['Start Date can not greater than End Date'];
      }
      return [];
    },
    startSubmittedDateRules() {
      if (this.end_date_submitted < this.start_date_submitted) {
        return ['End Date can not lower than Start Date'];
      }
      return [];
    },
    endSubmittedDateRules() {
      if (this.start_date_submitted > this.end_date_submitted) {
        return ['Start Date can not greater than End Date'];
      }
      return [];
    },
    startApprovedDateRules() {
      if (this.end_date_fully_approved < this.start_date_fully_approved) {
        return ['End Date can not lower than Start Date'];
      }
      return [];
    },
    endApprovedDateRules() {
      if (this.start_date_fully_approved > this.end_date_fully_approved) {
        return ['Start Date can not greater than End Date'];
      }
      return [];
    },
    yearStartRules() {
      if (this.yearEnd < this.start_year) {
        return ['Year End can not lower than Year Start'];
      }
      return [];
    },
    yearEndRules() {
      if (this.start_year > this.yearEnd) {
        return ['Year Start can not greater than Year End'];
      }
      return [];
    }
  },
  watch: {
    menu_start_year(val) {
      val &&
        this.$nextTick(
          () => (this.$refs.pickerStartYear.activePicker = 'YEAR')
        );
    },
    region(val) {
      const region = this.regionItems.find(item => item.name === val);
      if (val) {
        this.district = null;
        this.fetchDistricts(region?.id);
      }
    }
  },
  mounted() {
    this.fetchRegions();
    this.fetchHousesNAV();
    this.fetchDistricts();
    this.fetchActivities();
  },
  methods: {
    setFilter(val = {}) {
      this.$store.commit('sshcp/set', {
        filter: {
          start_year: this.start_year,
          start_created_date: this.start_created_date,
          end_created_date: this.end_created_date,
          start_date_submitted: this.start_date_submitted,
          end_date_submitted: this.end_date_submitted,
          start_date_fully_approved: this.start_date_fully_approved,
          end_date_fully_approved: this.end_date_fully_approved,
          house: this.house,
          region: this.region,
          district: this.district,
          type_of_activity: this.activity,
          status: this.status,
          ...val
        }
      });
    },
    resetFilter() {
      this.setFilter({
        start_year: '',
        start_created_date: '',
        end_created_date: '',
        start_date_submitted: '',
        end_date_submitted: '',
        start_date_fully_approved: '',
        end_date_fully_approved: '',
        yearEnd: '',
        house: null,
        region: null,
        district: null,
        type_of_activity: null,
        status: null,
        isSubmit: true
      });
      this.$emit('reset');
    },
    handleFilter() {
      if (this.$refs.form.validate()) {
        this.setFilter({
          isSubmit: true
        });
        this.$emit('filter');
        this.dialog = false;
      }
    },
    fetchHousesNAV() {
      this.$store
        .dispatch('house/getAll', {
          paginate: false
        })
        .then(data => {
          this.housesNAV = data.data;
        });
    },
    fetchRegions() {
      this.$store.dispatch('sshcp/getRegionsMapping', {
        paginate: false
      });
    },
    fetchDistricts(id) {
      if (!id) return;

      this.$store.dispatch('sshcp/getDistrictByRegion', {
        id: id,
        paginate: false
      });
    },
    fetchActivities() {
      this.$store.dispatch('sshcp/getActivities', {
        paginate: false
      });
    }
  }
};
</script>

<style>
.drawer-menu--scroll-dialog {
  max-height: 450px;
  overflow: auto;
}
</style>
